import React from 'react';
import styles from './DotWave.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const DotWave = ({
  width = '',
  height = '',
  backgroundColor = '',
  number = 0,
}) => {
  return (
    <div className={cx('DotWave')}>
      <div className="loading-bar">
        <LoadingCircle
          backgroundColor={backgroundColor}
          height={height}
          width={width}
          number={number}
        />
      </div>
    </div>
  );
};

export default DotWave;

const LoadingCircle = ({
  backgroundColor = '',
  width = '',
  height = '',
  number = 0,
}) => {
  const loadingList = () => {
    const l = [];
    for (let i = 0; i < number; i++) {
      l.push(i);
    }
    return l;
  };

  return loadingList().map((data, i) => {
    return (
      <div>
        <div
          className={`loading move${i + 1}`}
          style={{
            backgroundColor: backgroundColor,
            width: width,
            height: height,
          }}
          key={`loading-${data}`}
        ></div>
      </div>
    );
  });
};
